// Global fetch interceptor.
// Amaç: Access token kısa ömürlü (15 dk) kalsın ama oturum kullanıcı fark etmeden
// otomatik yenilensin. Her API isteğine GÜNCEL Bearer token eklenir; 401 dönerse
// /api/auth/refresh ile token sessizce yenilenir ve istek BİR KEZ tekrarlanır.
// Yenileme de başarısız olursa oturum temizlenip /login'e yönlendirilir.
//
// Tek sefer kurulur (src/index.js). Sayfaların fetch çağrılarını değiştirmeye gerek yok.

const API_BASE = "https://harmanappapi.stechomeyazilim.info";
const REFRESH_URL = `${API_BASE}/api/auth/refresh`;

let refreshPromise = null; // Eşzamanlı 401'lerde tek yenileme yapılsın (single-flight).

const getToken = () => localStorage.getItem("token");
const getRefreshToken = () => localStorage.getItem("refreshToken");

const isApiRequest = (url) => typeof url === "string" && url.indexOf(API_BASE) === 0;
const isAuthEndpoint = (url) => typeof url === "string" && url.indexOf("/api/auth/") !== -1;

const withAuthHeader = (init, token) => {
  const headers = new Headers((init && init.headers) || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);
  return { ...(init || {}), headers };
};

const clearSessionAndRedirect = () => {
  localStorage.removeItem("authUser");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  if (window.location.pathname.indexOf("/login") === -1) {
    window.location.href = "/login";
  }
};

// Refresh token ile yeni access token al. Başarılıysa yeni token'ı döndürür.
const refreshAccessToken = (originalFetch) => {
  const rt = getRefreshToken();
  if (!rt) return Promise.resolve(null);

  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const res = await originalFetch(REFRESH_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ RefreshToken: rt }),
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (data && data.Token) {
          localStorage.setItem("token", data.Token);
          // Backend token rotation yapıyor — yeni refresh token'ı da sakla.
          if (data.RefreshToken) localStorage.setItem("refreshToken", data.RefreshToken);
          try {
            const au = JSON.parse(localStorage.getItem("authUser"));
            if (au) {
              au.Token = data.Token;
              localStorage.setItem("authUser", JSON.stringify(au));
            }
          } catch (e) { /* authUser parse edilemezse önemli değil */ }
          return data.Token;
        }
        return null;
      } catch (e) {
        return null;
      } finally {
        refreshPromise = null;
      }
    })();
  }
  return refreshPromise;
};

export function installAuthFetch() {
  if (typeof window === "undefined" || window.__authFetchInstalled) return;
  if (typeof window.fetch !== "function") return;

  const originalFetch = window.fetch.bind(window);
  window.__authFetchInstalled = true;

  window.fetch = async (input, init) => {
    const url = typeof input === "string" ? input : (input && input.url);

    // API dışı istekler ve auth endpoint'leri (login/refresh) aynen geçer.
    if (!isApiRequest(url) || isAuthEndpoint(url)) {
      return originalFetch(input, init);
    }

    // Request objesi (string olmayan input) ile çağrı bu kod tabanında kullanılmıyor;
    // güvenli tarafta kalmak için header enjeksiyonu yapmadan geçiririz.
    if (typeof input !== "string") {
      return originalFetch(input, init);
    }

    const token = getToken();
    let opts = token ? withAuthHeader(init, token) : init;

    let res = await originalFetch(input, opts);
    if (res.status !== 401) return res;

    // 401 → token'ı yenile, isteği bir kez tekrarla.
    const newToken = await refreshAccessToken(originalFetch);
    if (!newToken) {
      clearSessionAndRedirect();
      return res;
    }
    return originalFetch(input, withAuthHeader(init, newToken));
  };
}
